import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../models/response';
import { environment } from 'src/environments/environment';

const calendarURL = `${environment.api}/calendar/`;
const scheduleRedistributionURL = `${environment.api}/schedule-redistribution/`;
@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private readonly http = inject(HttpClient);

  /**
   * Invia una nuova richiesta calendario standard:
   * ferie, permesso, malattia oppure modifica presenza/smart.
   */
  storeRequest(data: any): Observable<Response<any>> {
    return this.http.post<Response<any>>(
      calendarURL + 'storeEventRequest',
      data
    );
  }

  /**
   * Aggiorna una richiesta calendario già esistente mantenendo il flusso BE
   * storico dedicato alle modifiche.
   */
  updateRequest(data: any): Observable<Response<any>> {
    return this.http.patch<Response<any>>(
      calendarURL + 'updateEventRequest',
      data
    );
  }

  /**
   * Conferma il secondo step della malattia allegando i dati richiesti dal
   * backend.
   */
  confirmIllnessRequest(data: any): Observable<Response<any>> {
    return this.http.post<Response<any>>(calendarURL + 'confirmsIllness', data);
  }

  /**
   * Recupera la settimana di presenza/smart mostrata nella modale standard
   * "Gestione presenze".
   */
  getWeek(date: { start_date: string; end_date: string }): Observable<any> {
    return this.http.post<Response<any>>(
      calendarURL + 'typeOfWorkForWeek',
      date
    );
  }

  /**
   * Recupera la settimana effettiva part-time per uno specifico utente e per
   * il lunedì selezionato in modale.
   *
   * Il backend restituisce la distribuzione standard del contratto oppure
   * l'override già approvato per quella settimana.
   */
  getPartTimeWeek(
    userId: string,
    weekStart: string
  ): Observable<Response<any>> {
    return this.http.get<Response<any>>(
      `${scheduleRedistributionURL}week/${userId}/${weekStart}`
    );
  }

  /**
   * Invia una richiesta di modifica della distribuzione oraria settimanale
   * riservata agli utenti part-time.
   */
  storePartTimeWeekChange(data: any): Observable<Response<any>> {
    return this.http.post<Response<any>>(
      scheduleRedistributionURL + 'store',
      data
    );
  }

  /**
   * Recupera lo storico delle richieste di ridistribuzione oraria per un
   * utente specifico.
   */
  getPartTimeWeekChangeHistory(userId: string): Observable<Response<any>> {
    return this.http.get<Response<any>>(
      `${scheduleRedistributionURL}history/${userId}`
    );
  }

  /**
   * Conferma una richiesta pending di ridistribuzione oraria part-time.
   */
  approvePartTimeWeekChange(
    requestId: string | number
  ): Observable<Response<any>> {
    return this.http.patch<Response<any>>(
      `${scheduleRedistributionURL}${requestId}/approve`,
      {}
    );
  }

  /**
   * Rifiuta una richiesta pending di ridistribuzione oraria part-time.
   */
  rejectPartTimeWeekChange(
    requestId: string | number,
    data: { rejection_reason: string }
  ): Observable<Response<any>> {
    return this.http.patch<Response<any>>(
      `${scheduleRedistributionURL}${requestId}/reject`,
      data
    );
  }
}
